import { useAtom, useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { summaryMappingAtom, updatingAtom } from './atoms'
import { Box, Button } from '@mui/material'
import React, { useMemo } from 'react'
import { Table } from 'shared/ui/Table/Table'
import { Column } from 'shared/ui/Table/types'
import { SummaryData } from './types'
import {
  useAddMapping,
  useOpenAdminColumn,
  useOpenKiddomColumn,
  useUpdateAll,
} from './hooks'
import { ConfirmCommitButton } from 'shared/ui'
import { atom } from 'infrastructure/state/jotai.wrapper'

const showTableAtom = atom(false)

export function ToDo() {
  return (
    <Box>
      <IsOpenToggle />
      <ToDoTable />
    </Box>
  )
}

function IsOpenToggle() {
  const [isOpen, toggleOpen] = useAtom(showTableAtom)
  const mappings = useAtomValue(summaryMappingAtom)
  if (isOpen || !mappings) return null
  return (
    <Box>
      <Button
        color="inherit"
        variant="outlined"
        onClick={() => toggleOpen(!isOpen)}
      >
        <strong>To Do:</strong> {Object.entries(mappings.mapped).length}
      </Button>
    </Box>
  )
}

function useColumns(): Column<[string, SummaryData[]]>[] {
  const updating = useAtomValue(updatingAtom)
  const addMapping = useAddMapping()
  const openKiddom = useOpenKiddomColumn()
  const openAdmin = useOpenAdminColumn()
  return useMemo(() => {
    return [
      openKiddom,
      openAdmin,
      {
        title: 'Add Mapping',
        width: 200,
        rowContent: (mapping: [string, SummaryData[]]) => {
          return (
            <ConfirmCommitButton
              disabled={updating}
              onClick={() => addMapping(mapping)}
            >
              Add Mapping
            </ConfirmCommitButton>
          )
        },
      },
    ]
  }, [openKiddom, openAdmin, addMapping, updating])
}

function ToDoTable() {
  const updating = useAtomValue(updatingAtom)
  const [tableOpen, toggleTable] = useAtom(showTableAtom)
  const mappings = useAtomValue(summaryMappingAtom)
  const columns = useColumns()
  const updateAll = useUpdateAll()
  const items = useMemo(() => {
    if (!mappings) return
    return Object.entries(mappings.mapped)
  }, [mappings])
  if (!items || !tableOpen) return null

  if (!mappings || !tableOpen) return null
  return (
    <Table
      columns={columns}
      title={`To Do: ${items.length}`}
      items={items}
      overrideHeight={200}
      toolBarItems={[
        <ConfirmCommitButton
          disabled={updating}
          key="updateAll"
          onClick={updateAll}
        >
          Update All
        </ConfirmCommitButton>,
        <Button key="hideTable" onClick={() => toggleTable(false)}>
          Hide Table
        </Button>,
      ]}
    />
  )
}
